import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col max-w-[40rem] mx-auto pb-24" }
const _hoisted_2 = { class: "flex flex-col gap-5" }
const _hoisted_3 = { class: "w-7 h-7 mr-1 flex items-center justify-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "flex-grow text-left text-sm" }, "Where will you belong?", -1)
const _hoisted_5 = { class: "w-7 h-7 bg-light-gray-100 flex flex-col items-center justify-center rounded-md p-1 text-light-gray-200" }

import { onMounted, watch, computed } from "vue"
  import { useCompanyStore } from "@/store/company"
  import { useMetadataStore } from "@/store/metadata"
  import { map } from "lodash"

  import * as numeral from "numeral"
  import { search, optionsOutline } from "ionicons/icons"
  import { IonContent, IonButton, IonIcon, IonNavLink, loadingController, IonInfiniteScroll, IonInfiniteScrollContent } from "@ionic/vue"
  import SearchPage from "@/views/job-board/SearchPage.vue"
  import DisoverCard from "@/components/discover-page/DisoverCard.vue"
  import Menubar from "@/components/menuBar.vue"
  // image

  
export default /*#__PURE__*/_defineComponent({
  __name: 'JobBoardPage',
  setup(__props) {

  const companyStore = useCompanyStore()
  const metadataStore = useMetadataStore()
  const jobs = computed(() => {
    return map(companyStore.allJobs, (obj) => {
      let subtext = ""
      if (obj.salary && (obj.salary.minimum || obj.salary.maximum)) {
        const { currency, minimum, maximum } = obj.salary
        subtext = `<span class="font-bold"> ${currency ? currency : ""} ${minimum && minimum !== maximum ? numberWithComma(minimum) : ""} ${minimum && maximum && minimum !== maximum ? " - " : ""} ${
          maximum ? numberWithComma(maximum) : ""
        }</span> / month`
      }
      return {
        id: obj.id,
        slug: `/job-board/${obj.company_slug}/${obj.slug}/${toSlug(obj.title.toLowerCase())}`,
        image: obj.display_link ? obj.display_link : "",
        color: obj.company_color,
        location: obj.company_location?.full_address ? obj.company_location.full_address : obj.company_location?.country ? obj.company_location?.country : "",
        logo: obj.company_logo,
        name: obj.title,
        subtext,
        follows: obj.follows,
      }
    })
  })
  const loadData = async () => {
    companyStore.filterParams.page += 1
    companyStore.isNewState = false
  }

  /**
   *
   * @param title - (string)
   * return slugified title
   */
  const toSlug = (title: string) => {
    return title
      .trim()
      .replace(/&/g, "and")
      .replace(/\//g, " or ")
      .replace(/\s+/g, "-")
      .replace(/[^a-zA-Z0-9\- ]/g, "")
      .replace(/--/g, "-")
  }

  /**
   * @number - either number or string
   * return the number with comma
   */
  const numberWithComma = (number: number | string) => {
    return numeral(number).format("0,0")
  }

  const initJob = async () => {
    const loading = await loadingController.create({
      spinner: null,
      message: "Retrieving...",
      translucent: true,
      backdropDismiss: false,
    })
    await loading.present()
    await companyStore.retrieveAllJobs(companyStore.filterParams)
    loading.dismiss()
  }
  onMounted(async () => {
    companyStore.generateFilter(true)
    companyStore.filterParams.limit = 15
    companyStore.filterParams.sort = "alphabetical"
    companyStore.filters.sort = "alphabetical"
    companyStore.isNewState = true
    metadataStore.details.title = "Job Vacancies & Openings - Job Board Philippines | Workbean"
    metadataStore.details.description = "Workbean's job hiring platform will help you find opportunities for a new work from home, remote, or startup job within the Philippines. Explore job openings."
    metadataStore.details.og.title = "Job Vacancies & Openings - Job Board Philippines | Workbean"
    metadataStore.details.og.description =
      "Workbean's job hiring platform will help you find opportunities for a new work from home, remote, or startup job within the Philippines. Explore job openings."
    metadataStore.details.twitter.title = "Job Vacancies & Openings - Job Board Philippines | Workbean"
    metadataStore.details.twitter.description =
      "Workbean's job hiring platform will help you find opportunities for a new work from home, remote, or startup job within the Philippines. Explore job openings."
  })
  watch(
    () => companyStore.filterParams,
    () => initJob(),
    { deep: true }
  )

return (_ctx: any,_cache: any) => {
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createBlock(_unref(IonContent), { class: "ion-padding" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Menubar),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(IonNavLink), {
            "router-direction": "forward",
            component: SearchPage
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButton), {
                expand: "block",
                color: "white",
                size: "large",
                class: "text-xl text-primary-black normal-case flex flex-row justify-between items-center gap-5"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, [
                    _createVNode(_unref(IonIcon), { icon: _unref(search) }, null, 8, ["icon"])
                  ]),
                  _hoisted_4,
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_unref(IonIcon), { icon: _unref(optionsOutline) }, null, 8, ["icon"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_ion_list, { lines: "none" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(jobs), (job) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                key: job.slug
              }, {
                default: _withCtx(() => [
                  _createVNode(DisoverCard, {
                    detail: job,
                    "discover-type": "job"
                  }, null, 8, ["detail"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_unref(IonInfiniteScroll), {
          id: "infinite-scroll",
          threshold: "100px",
          disabled: _unref(companyStore).isLast,
          onIonInfinite: _cache[0] || (_cache[0] = ($event: any) => (loadData()))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInfiniteScrollContent), {
              "loading-spinner": "bubbles",
              "loading-text": "Loading more data..."
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})